import React from 'react';
import ReactDOM from 'react-dom';
import ShipcampsLeadGenLandingPage from 'pages/ShipcampsLeadGenLandingPage';

document.addEventListener('DOMContentLoaded', () => {
  ReactDOM.render(
    <ShipcampsLeadGenLandingPage />,
    document.body.appendChild(document.createElement('div')),
  )
});
